module.exports = __webpack_public_path__ + "img/ic_new-folder.603fa1e0.svg";